<template>
  <div>
    <CommonExpansionPanel>
      <template v-slot:title-panel>
        Cuerpo de correo
      </template>
      <v-expansion-panel-content>
        <div v-if="loading" style="justify-items: center;">
          <v-img
            class="responsive"
            contain
            max-height="200"
            max-width="300"
            :src="loader.createAccount"
          ></v-img>
          <div>Cargando cuerpo de correo ....</div>
        </div>
        <div v-else>
          <div v-html="htmlContent"></div>
          <div style="padding-top: 40px;">
            {{ textPlane }}
          </div>
          <div v-html="otros"></div>
        </div>
      </v-expansion-panel-content>
    </CommonExpansionPanel>
  </div>
</template>

<script>
import CommonExpansionPanel from "@/components/commonComponents/CommonExpansionPanel.vue";
import loginData from "@/helpers/data/data-login-template.json";
export default {
  components: {
    CommonExpansionPanel,
  },

  data() {
    return {
      switch_data: 1,
      solicitudes: [],
      filtros: [],
      loading: true,
      loader: loginData,
      htmlContent: null,
      textPlane: "",
      otros: null,
    };
  },
  props: {
    datosSolicitud: Object,
  },
  mounted() {
    this.fillData();
  },
  watch: {
    datosSolicitud() {
      this.fillData();
    },
  },
  methods: {
    fillData() {
      // Obtenemos 'detalle' del body (puede venir como string o como objeto)
      const { solicitudBody } = this.datosSolicitud || {};
      const detalleRaw = solicitudBody?.detalle;

      let jsonDetalle = {};
      if (typeof detalleRaw === "string") {
        try {
          jsonDetalle = JSON.parse(detalleRaw);
        } catch (error) {
          console.error("Error al parsear detalle:", error);
          jsonDetalle = {};
        }
      } else if (typeof detalleRaw === "object" && detalleRaw !== null) {
        jsonDetalle = detalleRaw;
      }

      // Extraemos el array o valor único de "text/html"
      const htmlField = jsonDetalle["text/html"];
      let htmlContent = null;
      if (Array.isArray(htmlField) && htmlField.length > 0) {
        htmlContent = htmlField[0];
      } else if (typeof htmlField === "string") {
        htmlContent = htmlField;
      }

      // Limpiamos saltos de línea 
      this.htmlContent = htmlContent
        ? htmlContent.replace(/\r?\n|\r/g, "")
        : null;

      // Otros formatos
      this.textPlane = jsonDetalle["text/plain"] || detalleRaw;
      this.otros = jsonDetalle["others"] || null;

      this.loading = false;
    },
  },
};
</script>
